// 投資用物件一覧テーブルカラム定義
const ColumnInvestment = [
  {
    name: '物件ID 物件管理番号 登録店舗 自社担当者',
    cd: 'display1',
  },
  {
    name: '外観・間取り',
    cd: 'display2',
  },
  {
    name: '種別 物件名 階建・所在階・号室',
    cd: 'display3',
  },
  {
    name: '住所 駅・徒歩',
    cd: 'display4',
  },
  {
    name: '間取り 築年数 向き',
    cd: 'display5',
  },
  {
    name: '価格 管理費 修繕積立金',
    cd: 'display6',
  },
  {
    name: '土地面積 建物面積 専有面積',
    cd: 'display7',
  },
  {
    name: '取引態様 確認日 販売状態 現況',
    cd: 'display8',
  },
  {
    name: '権利 建ぺい率 容積率',
    cd: 'display9',
  },
  {
    name: '坪単価 用途地域 都市計画',
    cd: 'display10',
  },
  {
    name: '利回り 総戸数 満室時年収・月収',
    cd: 'display11',
  },
  {
    name: 'クローズ情報',
    cd: 'display12',
  },
  {
    name: 'フリータグ',
    cd: 'display13',
  },
  {
    name: '備考',
    cd: 'display14',
  },
  {
    name: '作成日 更新日',
    cd: 'display15',
  },
  {
    name: '業者名 担当者・連絡先',
    cd: 'display16',
  },
  {
    name: '画像数 パノラマ画像数',
    cd: 'display17',
  },
]

export default ColumnInvestment
